import { tagsPermitidasAPI } from "@enums/TemplatesEmail/Tags";

export default function ValidationsTemplateEmail() {

    const validateFields = (fields) => {
        const {
            nome,
            titulo,
            tipoEmail,
            conteudo
        } = fields;
        const errors = {};

        if (!nome.trim()) errors.nome = "O campo Nome é obrigatório.";
        if (!titulo.trim()) errors.titulo = "O campo Título é obrigatório.";
        if (!conteudo.trim()) errors.conteudo = "O campo Conteúdo é obrigatório.";
        if (!tipoEmail) errors.tipoEmail = "O Tipo de Email é obrigatório.";

        return errors;
    };

    const validateTags = (conteudo) => {
        if (typeof conteudo !== 'string') return {
            valid: false,
            invalidTags: [],
            message: 'Conteúdo inválido'
        };

        const tagsSet = new Set(tagsPermitidasAPI.map(tag => tag.tag));
        const regex = /#(.*?)#/g;

        let match;
        const tagsEncontradas = [];
        const tagsInvalidas = [];

        while ((match = regex.exec(conteudo)) !== null) {
            const tag = match[1];
            tagsEncontradas.push(tag);

            if (!tagsSet.has(tag)) {
                tagsInvalidas.push(`#${tag}#`);
            }
        }

        const numHashes = (conteudo.match(/#/g) || []).length;
        const hashesValidos = numHashes % 2 === 0;

        return {
            valid: tagsInvalidas.length === 0 && hashesValidos,
            invalidTags: tagsInvalidas,
            message: hashesValidos ? '' : 'Número ímpar de caracteres # detectado.',
        };
    };

    return {
        validateFields,
        validateTags
    }
}
